import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { ModalPDFViewerConfig, PdfViewerComponent } from 'src/app/shared/components/pdf-viewer/pdf-viewer.component';

@Injectable()
export class ModalPDFViewerService {
  constructor(
    private modalService: BsModalService
  ) { }

  public show(config: ModalPDFViewerConfig): Promise<{ value: any, data: any }> {
    const modalClass = `modal-${config.modalClass || 'xl'}`;
    return new Promise((resolve, reject) => {
      let settled = false;
      let onHiddenSubscription: Subscription | undefined;

      const resolveOnce = (result?: { value: any, data: any }): void => {
        if (settled) {
          return;
        }
        settled = true;
        onHiddenSubscription?.unsubscribe();
        resolve(result);
      };

      const rejectOnce = (reason?: any): void => {
        if (settled) {
          return;
        }
        settled = true;
        onHiddenSubscription?.unsubscribe();
        reject(reason);
      };

      const modal = this.modalService.show(PdfViewerComponent, { class: modalClass });

      // O modal também pode ser fechado por Esc, backdrop ou pelo próprio
      // BsModalService. Nesses caminhos o componente não chama hide(), então
      // sua Promise ficava pendente e o PDFService mantinha os próximos PDFs
      // presos na fila indefinidamente.
      onHiddenSubscription = modal.onHidden?.subscribe(() => resolveOnce());
      modal.content.setOption(resolveOnce, rejectOnce, config);
    });
  }
}
